export default "__VITE_ASSET__DW$p6nk___"